import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Details from "../Tabs/Details";
import Tracking from "../Tabs/Tracking";
import Payment from "../Tabs/Payment";


export default function OrderDetails() {
  const [activeTab, setActiveTab] = useState("details");
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderId = params.get("id"); // Default order ID for fallback
  const tabName = params.get("tab");

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    navigate(`?id=${orderId}&tab=${tabName}`);
  };

  useEffect(() => {
    setActiveTab(tabName || "details");
  }, [tabName]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header card-header2">
                <div className="d-flex">
                  <Link
                    to={`?id=${orderId}&tab=details`}
                    className={`${
                      activeTab === "details" ? "active-tab" : ""
                    } card-title--medium card-title2`}
                    onClick={() => handleTabChange("details")}
                  >
                    Order Details
                  </Link>
                  {/* <Link
                    to={`?id=${orderId}&tab=tracking`}
                    className={`${
                      activeTab === "tracking" ? "active-tab" : ""
                    } card-title--medium card-title2 ms-5`}
                    onClick={() => handleTabChange("tracking")}
                  >
                    Order Tracking
                  </Link> */}
                   {/* <Link
                    to={`?id=${orderId}&tab=payment`}
                    className={`${
                      activeTab === "payment" ? "active-tab" : ""
                    } card-title--medium card-title2 ms-5`}
                    onClick={() => handleTabChange("payment")}
                  >
                    Retailer Oreder Payment
                  </Link> */}
                </div>
                <h5 className="order-id card-title--medium card-title2">Order ID: {orderId}</h5>
              </div>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === "details" && <Details />}
                {activeTab === "tracking" && <Tracking />}
                {activeTab === "payment" && <Payment />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
